import React from "react";
import T from "prop-types";
import DropDownItem from "MODULES/shared/components/DropDown/DropDownItem";
import { withSalesOrder } from "MODULES/SalesOrders/decorators";
import { translateProps, toggleSwitch } from "MODULES/shared/decorators";
import { Icon, ConfirmAction } from "MODULES/shared/components";
import { ACCOUNTING_HOLD } from "MODULES/SalesOrders/constants";

export function Release({ hold, releasing, open, close, release }) {
  return (
    hold && (
      <DropDownItem onClick={open}>
        <ConfirmAction
          key="confirm"
          open={releasing}
          close={close}
          btnText="Release"
          onConfirm={release}
        >
          <strong>Heads up!</strong>
          &nbsp;Release SO from Accounting hold?
        </ConfirmAction>
        <Icon name="play" fixed />
        &nbsp;Release From Accounting Hold
      </DropDownItem>
    )
  );
}

Release.propTypes = {
  hold: T.bool,
  releasing: T.bool.isRequired,
  open: T.func.isRequired,
  close: T.func.isRequired,
  release: T.func.isRequired
};

const withProps = translateProps(({ salesOrder, updateSalesOrder }) => ({
  release: () => updateSalesOrder({ accounting_hold: false }),
  hold: salesOrder.get(ACCOUNTING_HOLD)
}));

export default withSalesOrder(toggleSwitch("releasing")(withProps(Release)));



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Actions/Release.jsx